<template>
  <footer class="bg-[#111111] text-white pt-16 pb-12">
    <div class="max-w-[1380px] mx-auto px-5 lg:px-6">
      <!-- Main Content Grid -->
      <div class="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 pb-16">
        <!-- Left Section (Brand, Tagline, Social Media Rounded Icons) -->
        <div class="lg:col-span-5 flex flex-col justify-between space-y-6">
          <div class="space-y-4">
            <!-- Brand Logo -->
            <a href="#beranda" class="inline-block">
              <img
                src="@/assets/images/logopesona.webp"
                alt="Logo PESONA"
                class="h-9 w-auto object-contain brightness-0 invert"
              />
            </a>
            <!-- Tagline / Address info -->
            <p class="text-[#8e8e93] text-[14px] leading-relaxed max-w-sm">
              Universitas Teknologi Digital Indonesia (UTDI) — Jl. Raya Janti Karang Jambe No. 143, Yogyakarta 55198.
            </p>
          </div>

          <!-- Social Media Icons (Rounded square style like reference) -->
          <div class="flex items-center gap-2.5 pt-2">
            <!-- YouTube -->
            <a
              href="https://www.youtube.com/c/UniversitasTeknologiDigitalIndonesia"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube UTDI"
              class="w-10 h-10 rounded-xl bg-[#222222] hover:bg-[#2d2d2d] text-[#c7c7cc] hover:text-white flex items-center justify-center transition-colors duration-200"
            >
              <i class="fab fa-youtube text-[15px]"></i>
            </a>

            <!-- TikTok -->
            <a
              href="https://www.tiktok.com/@utdi_official"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="TikTok UTDI"
              class="w-10 h-10 rounded-xl bg-[#222222] hover:bg-[#2d2d2d] text-[#c7c7cc] hover:text-white flex items-center justify-center transition-colors duration-200"
            >
              <i class="fab fa-tiktok text-[15px]"></i>
            </a>

            <!-- LinkedIn (Requested) -->
            <a
              href="https://www.linkedin.com/school/utdiofficial/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn UTDI"
              class="w-10 h-10 rounded-xl bg-[#222222] hover:bg-[#2d2d2d] text-[#c7c7cc] hover:text-white flex items-center justify-center transition-colors duration-200"
            >
              <i class="fab fa-linkedin-in text-[15px]"></i>
            </a>

            <!-- Facebook -->
            <a
              href="https://www.facebook.com/utdi.official/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook UTDI"
              class="w-10 h-10 rounded-xl bg-[#222222] hover:bg-[#2d2d2d] text-[#c7c7cc] hover:text-white flex items-center justify-center transition-colors duration-200"
            >
              <i class="fab fa-facebook-f text-[15px]"></i>
            </a>

            <!-- Instagram -->
            <a
              href="https://www.instagram.com/utdi_official/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram UTDI"
              class="w-10 h-10 rounded-xl bg-[#222222] hover:bg-[#2d2d2d] text-[#c7c7cc] hover:text-white flex items-center justify-center transition-colors duration-200"
            >
              <i class="fab fa-instagram text-[15px]"></i>
            </a>
          </div>
        </div>

        <!-- Right Columns (Navigation Links - 3 columns matching reference) -->
        <div class="lg:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-8">
          <!-- Col 1: Eksplorasi -->
          <div class="space-y-4">
            <h4 class="text-white text-[14px] font-medium tracking-tight">Eksplorasi</h4>
            <ul class="space-y-3 text-[14px]">
              <li>
                <a href="#beranda" class="text-[#8e8e93] hover:text-white transition-colors duration-150">
                  Beranda
                </a>
              </li>
              <li>
                <a href="#tentang" class="text-[#8e8e93] hover:text-white transition-colors duration-150">
                  Tentang Pesona
                </a>
              </li>
              <li>
                <a href="#kegiatan" class="text-[#8e8e93] hover:text-white transition-colors duration-150">
                  Jadwal Kegiatan
                </a>
              </li>
              <li>
                <a href="#teknopedia" class="text-[#8e8e93] hover:text-white transition-colors duration-150">
                  Teknopedia
                </a>
              </li>
              <li>
                <a href="https://www.utdi.ac.id" target="_blank" rel="noopener noreferrer" class="text-[#8e8e93] hover:text-white transition-colors duration-150">
                  Website Kampus
                </a>
              </li>
            </ul>
          </div>

          <!-- Col 2: Mahasiswa & Portal -->
          <div class="space-y-4">
            <h4 class="text-white text-[14px] font-medium tracking-tight">Portal Kampus</h4>
            <ul class="space-y-3 text-[14px]">
              <li>
                <a href="https://siakad.utdi.ac.id" target="_blank" rel="noopener noreferrer" class="text-[#8e8e93] hover:text-white transition-colors duration-150">
                  SIAKAD
                </a>
              </li>
              <li>
                <a href="https://elearning.utdi.ac.id" target="_blank" rel="noopener noreferrer" class="text-[#8e8e93] hover:text-white transition-colors duration-150">
                  E-Learning
                </a>
              </li>
              <li>
                <a href="https://keuportal.utdi.ac.id" target="_blank" rel="noopener noreferrer" class="text-[#8e8e93] hover:text-white transition-colors duration-150">
                  Keuportal
                </a>
              </li>
              <li>
                <a href="#tugas" class="text-[#8e8e93] hover:text-white transition-colors duration-150">
                  Pengumpulan Tugas
                </a>
              </li>
            </ul>
          </div>

          <!-- Col 3: Bantuan & Info -->
          <div class="space-y-4">
            <h4 class="text-white text-[14px] font-medium tracking-tight">Bantuan & Info</h4>
            <ul class="space-y-3 text-[14px]">
              <li>
                <a href="#faq" class="text-[#8e8e93] hover:text-white transition-colors duration-150">
                  FAQ Pesona
                </a>
              </li>
              <li>
                <a
                  href="https://docs.google.com/document/d/1ET3RKHhyS-GeFPoOU4XTAFVoDzwZfk88dm_WzKnlPAg/edit?usp=sharing"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="text-[#8e8e93] hover:text-white transition-colors duration-150"
                >
                  Panduan Peserta
                </a>
              </li>
              <li>
                <span class="text-[#8e8e93] block">
                  Jam Pelayanan:
                </span>
                <span class="text-white text-[13px] block mt-0.5">
                  08.00 - 16.00 WIB
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- Bottom Bar (Copyright left, Terms/Privacy right) -->
      <div class="pt-8 border-t border-[#222222] flex flex-col sm:flex-row items-center justify-center sm:justify-between gap-4 text-[13px] text-[#636366]">
        <p class="text-center sm:text-left">
          &copy; 2026 Universitas Teknologi Digital Indonesia. All Rights Reserved.
        </p>
        <div class="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-center">
          <p>Developed by:</p>
          <a href="https://github.com/CaturSetyono" target="_blank" rel="noopener noreferrer" class="hover:text-[#8e8e93] transition-colors">
            Catur Setyono
          </a>
          <a href="https://github.com/akbarwjyy" target="_blank" rel="noopener noreferrer" class="hover:text-[#8e8e93] transition-colors">
            Akbar Wijaya 
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup></script>

<style>
@import url("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css");
</style>
